import React, { useRef, useState } from "react";
import Loader from "../../components/loader";
import { useBalancerPoolsData } from "../../context/balancerPoolData";
import PoolsTable from "../poolDetail/PoolsTable";
import WalletConnect from "../../components/common/walletConnect/index";
import { PoolType } from "../poolDetail/balancer/types";
import { Button, Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import MarginIssueTable from "../../components/table/MarginIssueTable";
import UiTable from "../../components/table/Table";
import TextInput from "../../components/textinput/TextInput";
import VerticallyModal from "../../components/modal/VerticallyModal";
import UiButton from "../../components/button";
import {
  ERC20,
  MarginIssueManager,
  contractAddress,
} from "@verified-network/verified-sdk";

import { toast } from "react-toastify";
import {
  BrokeragesList,
  OneYearAsSeconds,
  SuccessToast,
  ToastOptions,
  financingInterest,
  networkLoanConstant,
  networks,
} from "../../utils/constants";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import Web3 from "web3";
import BigNumber from "bignumber.js";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { ethers } from "ethers";
import MarginManager from "../../utils/abi/MarginManager.json";
import { useGlobal } from "../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function MarginIssues(props) {
  let { data: marginIssues, loading } = useBalancerPoolsData(
    PoolType.MarginIssue
  );
  const [contractCallLoading, setContractCallLoading] = useState(false);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    userCountryCode,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  let marginManagerAddress, marginManagerContract, marginManagerContractVer;
  if (provider && provider.getSigner && chainId && address) {
    marginManagerAddress = contractAddress[chainId].BalancerMarginIssueManager;
    if (marginManagerAddress && signer) {
      marginManagerContract = new web3.eth.Contract(
        MarginManager.abi,
        marginManagerAddress
      );
      marginManagerContractVer = new MarginIssueManager(
        signer,
        marginManagerAddress
      );
    }
  }

  marginIssues = marginIssues.filter(
    (pl) => pl?.issueManager?.toLowerCase() === account?.toLowerCase()
  );
  marginIssues = marginIssues.sort(
    (a, b) => Number(b.createTime) - Number(a.createTime)
  );
  const modalContent = useRef(null);
  const [modalView, setModalView] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isFinancing, setIsFinancing] = useState(false);
  const [financingTitle, setFinancingTitle] = useState("Select Financing");
  const [financingAmounts, setFinancingAmounts] = useState({
    bid: 0,
    offer: 0,
  });
  const [isDividends, setIsDividends] = useState(false);
  const [dividendsTitle, setDividendsTitle] = useState("Select Dividends");
  const [dividendsAmounts, setDividendsAmounts] = useState({
    bid: 0,
    offer: 0,
  });
  const [isSwaps, setIsSwaps] = useState(false);
  const [swapsTitle, setSwapsTitle] = useState("Select Swaps");
  const [swapsAmounts, setSwapsAmounts] = useState({
    short: 0,
    long: 0,
  });
  const [collateralAmount, setCollateralAmount] = useState(0);
  const [withdrawalAmount, setWithdrawalAmount] = useState(0);
  const [columnSelected, setColumnSelected] = useState({
    security: "",
    currency: "",
    currencyName: "",
    currencyDecimals: 0,
    marginTokensPair: "",
    securitySymbol: "",
    balance: "0.0000",
    balanceRaw: "0",
  });
  const [showReport, setShowReport] = useState(false);
  const [brokerageAmount, setBrokerageAmount] = useState(0);
  const [brokerage, setBrokerage] = useState("Select Brokerage");
  const [securityBalance, setSecurityBalance] = useState("");

  const commonProps = {
    modalView,
    updateModalView: setModalView,
    showModal,
    updateShowModal: setShowModal,
    columnSelected,
    updateColumnSelected: setColumnSelected,
    chainId,
    marginManagerContract,
    web3,
    account,
  };

  const handleModalHide = () => {
    setModalView(1);
    setShowModal(false);
    setIsFinancing(false);
    setIsDividends(false);
    setIsSwaps(false);
    setFinancingTitle("Select Financing");
    setDividendsTitle("Select Dividends");
    setSwapsTitle("Select Swaps");
    setFinancingAmounts({ bid: 0, offer: 0 });
    setDividendsAmounts({ bid: 0, offer: 0 });
    setSwapsAmounts({ short: 0, long: 0 });
    setShowReport(false);
  };

  const headers = [
    { label: "Security", val: "marginSecurityName" },
    { label: "Security Type", val: "marginSecurityType" },
    { label: "Currency", val: "marginCurrencyName" },
    { label: "Start Date(UTC)", val: "createTime" },
    { label: "Status", val: "securityClosedStatus" },
    { label: "Call Action", val: "marginCallAction" },
  ];

  const handleSendCollateral = async () => {
    if (collateralAmount === 0) {
      alert(`${columnSelected.currencyName} amount cannot be zero(0)`);
    } else {
      setContractCallLoading(true);
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setContractCallLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await marginManagerContractVer._getMeeQuote(
          cashTokens[0]?.address,
          "sendCollateral",
          [
            columnSelected.currency,
            collateralAmount.toString(),
            columnSelected.security,
          ]
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setContractCallLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await marginManagerContractVer
        .sendCollateral(
          columnSelected.currency,
          collateralAmount.toString(),
          columnSelected.security,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then((res) => {
          setContractCallLoading(false);
          if (res?.status === 0) {
            setShowModal(false);
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(
              SuccessToast(transactionLink, "Sent collateral succesfully"),
              ToastOptions
            );
          } else {
            toast.error("Send collateral transaction failed", ToastOptions);
          }
        })
        .catch((err) => {
          setContractCallLoading(false);
          toast.error("Send collateral transaction failed", ToastOptions);
        });
    }
  };

  const getRateInSeconds = (amount, rate) => {
    const _rate = rate / 100;
    const amt = Number(
      Number(web3.utils.toWei(amount.toString(), "ether")) *
        (_rate / OneYearAsSeconds)
    ).toFixed(0);
    return amt;
  };

  const getInterestRatesInSeconds = (Amounts) => {
    if (Amounts["bid"]) {
      const bidInSeconds =
        Number(ethers.utils.parseEther(Amounts?.bid?.toString())) /
        OneYearAsSeconds;
      const offerInSeconds =
        Number(ethers.utils.parseEther(Amounts?.offer?.toString())) /
        OneYearAsSeconds;
      return {
        bid: bidInSeconds?.toFixed(0),
        offer: offerInSeconds?.toFixed(0),
      };
    } else if (Amounts["short"]) {
      const shortInSeconds =
        Number(ethers.utils.parseEther(Amounts?.short?.toString())) /
        OneYearAsSeconds;
      const longInSeconds =
        Number(ethers.utils.parseEther(Amounts?.long?.toString())) /
        OneYearAsSeconds;
      return {
        short: shortInSeconds?.toFixed(0),
        long: longInSeconds?.toFixed(0),
      };
    }
    return;
  };

  const handleSettleAccount = async () => {
    let isValidated = true;
    if (
      !isFinancing ||
      financingAmounts.bid === 0 ||
      financingAmounts.offer === 0
    ) {
      alert("Input Financing Interest Percentages");
      isValidated = false;
    }
    if (
      (isDividends && dividendsAmounts.bid === 0) ||
      (isDividends && dividendsAmounts.offer === 0)
    ) {
      alert("Input Dividend  Percentages");
      isValidated = false;
    }
    if (
      (isSwaps && swapsAmounts.short === 0) ||
      (isSwaps && swapsAmounts.long === 0)
    ) {
      alert("Input Swap Percentages");
      isValidated = false;
    }
    if (columnSelected.tokensPair === "") {
      isValidated = false;
    }

    const financingRates = getInterestRatesInSeconds(financingAmounts);
    let dividendRates = { bid: 0, offer: 0 };
    let swapRates = { short: 0, long: 0 };
    if (dividendsAmounts.bid !== 0 && dividendsAmounts.offer !== 0) {
      dividendRates = getInterestRatesInSeconds(dividendsAmounts);
    }
    if (swapsAmounts.short !== 0 && swapsAmounts.long !== 0) {
      swapRates = getInterestRatesInSeconds(swapsAmounts);
    }
    if (isValidated && financingRates) {
      setContractCallLoading(true);
      // console.log(
      //   "sending: ",
      //   // columnSelected.security,
      //   // columnSelected.currency,
      //   financingRates.bid.toString(),
      //   financingRates.offer.toString(),
      //   dividendRates.bid.toString(),
      //   dividendRates.offer.toString(),
      //   swapRates.long.toString(),
      //   swapRates.short.toString(),
      //   Math.floor(Date.now() / 1000)?.toString()
      // );

      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setContractCallLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await marginManagerContractVer._getMeeQuote(
          cashTokens[0]?.address,
          "onSettle",
          [
            columnSelected.security,
            columnSelected.currency,
            financingRates.bid.toString(),
            financingRates.offer.toString(),
            dividendRates.bid.toString(),
            dividendRates.offer.toString(),
            swapRates.long.toString(),
            swapRates.short.toString(),
            Math.floor(Date.now() / 1000)?.toString(),
          ]
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setContractCallLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await marginManagerContractVer
        .onSettle(
          columnSelected.security,
          columnSelected.currency,
          financingRates.bid.toString(),
          financingRates.offer.toString(),
          dividendRates.bid.toString(),
          dividendRates.offer.toString(),
          swapRates.long.toString(),
          swapRates.short.toString(),
          Math.floor(Date.now() / 1000)?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then((res) => {
          setContractCallLoading(false);
          if (res?.status === 0) {
            setShowModal(false);
            setIsFinancing(false);
            setIsDividends(false);
            setIsSwaps(false);
            setFinancingTitle("Select Financing");
            setDividendsTitle("Select Dividends");
            setSwapsTitle("Select Swaps");
            setFinancingAmounts({ bid: 0, offer: 0 });
            setDividendsAmounts({ bid: 0, offer: 0 });
            setSwapsAmounts({ short: 0, long: 0 });
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(
              SuccessToast(transactionLink, "Account settled succesfully"),
              ToastOptions
            );
          } else {
            toast.error("settle account transaction failed", ToastOptions);
          }
        })
        .catch((err) => {
          setContractCallLoading(false);
          console.log("err: ", err);
          toast.error("settle account transaction failed", ToastOptions);
        });
    }
  };

  const handleWithdraw = async () => {
    let isValidated = true;
    if (withdrawalAmount === 0) {
      alert("Input amount to withdraw");
      isValidated = false;
    }
    if (columnSelected.security === "") {
      isValidated = false;
    }
    if (columnSelected.currency === "") {
      isValidated = false;
    }
    if (isValidated) {
      setContractCallLoading(true);
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setContractCallLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await marginManagerContractVer._getMeeQuote(
          cashTokens[0]?.address,
          "withdraw",
          [
            columnSelected.security,
            columnSelected.currency,
            withdrawalAmount.toString(),
          ]
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setContractCallLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await marginManagerContractVer
        .withdraw(
          columnSelected.security,
          columnSelected.currency,
          withdrawalAmount.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then((res) => {
          setContractCallLoading(false);
          if (res?.status === 0) {
            setShowModal(false);
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(
              SuccessToast(transactionLink, "Withdrawn profit succesfully"),
              ToastOptions
            );
          } else {
            toast.error("Withdraw profit transaction failed", ToastOptions);
          }
        })
        .catch((err) => {
          setContractCallLoading(false);
          toast.error("Withdraw profit transaction failed", ToastOptions);
        });
    }
  };

  const handleTransferSecurity = async () => {
    if (Number(brokerageAmount) === 0) {
      alert(`${columnSelected.securitySymbol} amount cannot be zero(0)`);
    } else if (Number(brokerageAmount) > Number(columnSelected?.balanceRaw)) {
      alert(`Insufficient ${columnSelected?.securitySymbol} balance.`);
    } else if (
      provider?.getSigner &&
      columnSelected.security?.length > 0 &&
      chainId > 0
    ) {
      const brokerages = networkLoanConstant[chainId]?.Brokerages;
      if (
        brokerages &&
        brokerages[brokerage?.toUpperCase()]?.length > 0 &&
        Number(brokerageAmount) > 0
      ) {
        setContractCallLoading(true);
        const securityContract = new ERC20(signer, columnSelected.security);
        let paymentToken;

        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            account
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setContractCallLoading(false);
            toast.error(
              "No valid Cash Token on this network. Change network and try again.",
              ToastOptions
            );

            return;
          }
          paymentToken = cashTokens[0];
          const txQuote = await securityContract._getMeeQuote(
            cashTokens[0]?.address,
            "transfer",
            [brokerages[brokerage?.toUpperCase()], brokerageAmount.toString()]
          );

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
          ) {
            setContractCallLoading(false);
            toast.error(
              `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
              ToastOptions
            );

            return;
          }
        }
        await securityContract
          .transfer(
            brokerages[brokerage?.toUpperCase()],
            brokerageAmount.toString(),
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {}
          )
          .then((res) => {
            setContractCallLoading(false);
            if (res?.status === 0) {
              setShowModal(false);
              const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response.hash}`;
              toast.success(
                SuccessToast(
                  transactionLink,
                  "Transfered Security to Brokerage succesfully"
                ),
                ToastOptions
              );
            } else {
              toast.error("Transfer Security transaction failed", ToastOptions);
            }
          })
          .catch((err) => {
            console.error("failew with error: ", err);
            setContractCallLoading(false);
            toast.error("Transfered Security transaction failed", ToastOptions);
          });
      }
    }
  };

  let message, heading;
  if (modalView === 1) {
    heading = "Send Collateral";
    message = (
      <>
        {contractCallLoading ? <Loader /> : null}
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>{columnSelected.currencyName} Amount</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <TextInput
                  placeholder="Value of collateral"
                  fieldType="number"
                  onChange={(e) =>
                    setCollateralAmount(
                      Number(e.target.value) *
                        10 ** columnSelected.currencyDecimals
                    )
                  }
                  required
                />
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col className="pl-0">
                <UiButton
                  onClick={async () => {
                    await handleSendCollateral();
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Send Collateral"
                  type="submit"
                />
              </Col>
            </Row>
          </Row>
        </div>
      </>
    );
  } else if (modalView === 2) {
    heading = "Transfer Profit";
    message = (
      <>
        {contractCallLoading ? <Loader /> : null}
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>{columnSelected.currencyName} Amount</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <TextInput
                  placeholder="Amount to withdraw"
                  fieldType="number"
                  onChange={(e) =>
                    setWithdrawalAmount(
                      Number(e.target.value) *
                        10 ** columnSelected.currencyDecimals
                    )
                  }
                  required
                />
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col className="pl-0">
                <UiButton
                  onClick={async () => {
                    await handleWithdraw();
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Withdraw Profit"
                  type="submit"
                />
              </Col>
            </Row>
          </Row>
        </div>
      </>
    );
  } else if (modalView === 3) {
    heading = "Settle Accounts";
    message = (
      <>
        {contractCallLoading ? <Loader /> : null}
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Financing</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DropdownButton title={financingTitle}>
                  <DropdownItem
                    key={1}
                    onClick={() => {
                      setShowReport(false);
                      setIsFinancing(true);
                      setFinancingTitle("True");
                    }}
                  >
                    True
                  </DropdownItem>
                  <DropdownItem
                    kwy={2}
                    onClick={() => {
                      setShowReport(false);
                      setIsFinancing(false);
                      setFinancingTitle("False");
                      setFinancingAmounts({ bid: 0, offer: 0 });
                    }}
                  >
                    False
                  </DropdownItem>
                </DropdownButton>
              </Col>
            </Row>
            {isFinancing && (
              <>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Financing Bid %</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Finacing bid in %"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (financingAmounts.bid = Number(e.target.value))
                          : (financingAmounts.bid = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Financing Offer %</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Finacing offer in %"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (financingAmounts.offer = Number(e.target.value))
                          : (financingAmounts.offer = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
              </>
            )}
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Dividend</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DropdownButton title={dividendsTitle}>
                  <DropdownItem
                    key={1}
                    onClick={() => {
                      setShowReport(false);
                      setIsDividends(true);
                      setDividendsTitle("True");
                    }}
                  >
                    True
                  </DropdownItem>
                  <DropdownItem
                    kwy={2}
                    onClick={() => {
                      setShowReport(false);
                      setIsDividends(false);
                      setDividendsTitle("False");
                      setDividendsAmounts({ bid: 0, offer: 0 });
                    }}
                  >
                    False
                  </DropdownItem>
                </DropdownButton>
              </Col>
            </Row>
            {isDividends && (
              <>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Dividend Bid %</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Dividend bid in %"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (dividendsAmounts.bid = Number(e.target.value))
                          : (dividendsAmounts.bid = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Dividend Offer %</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Dividend offer in %"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (dividendsAmounts.offer = Number(e.target.value))
                          : (dividendsAmounts.offer = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
              </>
            )}
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 4, offset: 2 }} className="text-left">
                <b>Swaps</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DropdownButton title={swapsTitle}>
                  <DropdownItem
                    key={1}
                    onClick={() => {
                      setShowReport(false);
                      setIsSwaps(true);
                      setSwapsTitle("True");
                    }}
                  >
                    True
                  </DropdownItem>
                  <DropdownItem
                    kwy={2}
                    onClick={() => {
                      setShowReport(false);
                      setIsSwaps(false);
                      setSwapsTitle("False");
                      setSwapsAmounts({ short: 0, long: 0 });
                    }}
                  >
                    False
                  </DropdownItem>
                </DropdownButton>
              </Col>
            </Row>
            {isSwaps && (
              <>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Swap Short %</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Swap short in %"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (swapsAmounts.short = Number(e.target.value))
                          : (swapsAmounts.short = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Swap Long %</b>
                  </Col>
                  <Col className="pl-0" xs={3.5}>
                    <TextInput
                      placeholder="Swap long in %"
                      fieldType="number"
                      onChange={(e) => {
                        setShowReport(false);
                        Number(e.target.value) != NaN
                          ? (swapsAmounts.long = Number(e.target.value))
                          : (swapsAmounts.long = 0);
                      }}
                      required
                    />
                  </Col>
                </Row>
              </>
            )}
            {!showReport && (
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col className="pl-0">
                  <UiButton
                    onClick={() => {
                      setShowReport(true);
                    }}
                    buttonVariant="primary"
                    buttonClass="SignUpButton flex-1 ml-0"
                    buttonText="Continue"
                    type="submit"
                  />
                </Col>
              </Row>
            )}
            {showReport && (
              <>
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col xs={{ span: 4, offset: 2 }} className="text-left">
                    <b>Settle Account Report:</b>
                  </Col>
                </Row>

                {isFinancing && (
                  <>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Bid:</b>
                      </Col>
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>{Number(financingAmounts?.bid) * 100}%</b>
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Financing Offer:</b>
                      </Col>
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>{Number(financingAmounts?.offer) * 100}%</b>
                      </Col>
                    </Row>
                  </>
                )}

                {isDividends && (
                  <>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Dividend Bid:</b>
                      </Col>
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>{Number(dividendsAmounts?.bid) * 100}%</b>
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Dividend Offer:</b>
                      </Col>
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>{Number(dividendsAmounts?.offer) * 100}%</b>
                      </Col>
                    </Row>
                  </>
                )}

                {isSwaps && (
                  <>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Swaps Short:</b>
                      </Col>
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>{Number(swapsAmounts?.short) * 100}%</b>
                      </Col>
                    </Row>
                    <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>Swaps Long:</b>
                      </Col>
                      <Col xs={{ span: 4, offset: 2 }} className="text-left">
                        <b>{Number(swapsAmounts?.long) * 100}%</b>
                      </Col>
                    </Row>
                  </>
                )}
                <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                  <Col className="pl-0">
                    <UiButton
                      onClick={async () => {
                        await handleSettleAccount();
                      }}
                      buttonVariant="primary"
                      buttonClass="SignUpButton flex-1 ml-0"
                      buttonText="Settle Accounts"
                      type="submit"
                    />
                  </Col>
                </Row>
              </>
            )}
          </Row>
        </div>
      </>
    );
  } else if (modalView === 4) {
    heading = "Transfer Security To Brokerage";
    message = (
      <>
        {contractCallLoading ? <Loader /> : null}
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 3 }} className="text-left">
                <b>Security Balance</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <b>
                  {columnSelected?.balance} {columnSelected?.securitySymbol}
                </b>
              </Col>
            </Row>

            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 3 }} className="text-left">
                <b>Brokerage</b>
              </Col>
              <Col className="pl-0" xs={3.5}>
                <DropdownButton id="dropdown-basic-button" title={brokerage}>
                  {BrokeragesList.map((Brk, idx) => (
                    <>
                      <Dropdown.Item
                        key={idx}
                        onClick={(e) => {
                          setBrokerage(e.target.textContent);
                        }}
                      >
                        {Brk}
                      </Dropdown.Item>
                    </>
                  ))}
                </DropdownButton>
              </Col>
            </Row>

            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 3 }} className="text-left">
                {brokerage !== "Select Brokerage" && (
                  <b>Amount To Transfer To Brokerage({brokerage})</b>
                )}
                {brokerage === "Select Brokerage" && (
                  <b>Amount To Transfer To Brokerage</b>
                )}
              </Col>
              <Col className="pl-0" xs={3.5}>
                <TextInput
                  placeholder="Transfer Amount"
                  fieldType="number"
                  onChange={(e) =>
                    setBrokerageAmount(
                      ethers.utils.parseUnits(e.target.value?.toString(), 18)
                    )
                  }
                  required
                />
              </Col>
            </Row>

            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col className="pl-0">
                <UiButton
                  onClick={async () => {
                    await handleTransferSecurity();
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Transfer Security"
                  type="submit"
                />
              </Col>
            </Row>
          </Row>
        </div>
      </>
    );
  }

  // const options = {
  //   onClick: (event, row) => {
  //     onTransaction(row);
  //   },
  // };
  // const onTransaction = (row) => {
  //   console.log(props, row);
  //   props.history.push(
  //     `/margintransaction/${row.id}`
  //   );
  // };

  // onSettle(address security, address currency, uint256 financingPerSec, bool charge, uint256 dividendPerSec, bool payout, uint256 settlementTime)
  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="w-100">
            <h3 className="text-left">Margin Issues</h3>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={marginIssues ?? []}
            // rowEvents={options}
            hover
            bordered={false}
            chainId={chainId}
            contract={marginManagerContractVer}
            account={account}
            isUpdate
            commonProps={commonProps}
            marginManagerAddress={marginManagerAddress}
            web3={web3}
            verifiedWalletDetails={verifiedWalletDetails}
            signer={signer}
          />
        </div>
      </section>
      <VerticallyModal
        key="connectProvider"
        showModal={showModal}
        modalOnHide={handleModalHide}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>{heading}</b>
          </h2>
        }
        withFooter={false}
      >
        {message}
      </VerticallyModal>
      <WalletConnect loggedIn={props.loggedIn} />
    </>
  );
}

export default function MarginIssuesManager(props) {
  return <MarginIssues {...props} />;
}
